define('views/wellness/wellness',[
	'backbone',
	'views/_base/baseview',
	'text!views/wellness/wellness.html',
	'text!views/wellness/multipurse/multipurse.html',
	'views/wellness/multipurse/purse_item',
	'views/wellness/partner/resource',
	'views/wellness/account',
	'views/home/notification',
	'views/shared/modal/modal_modern',
], function (
	Backbone,
	BaseView,
	Template,
	MultiPurseTemplate,
	MultiPurseItemView,
	PartnerResourceView,
	AccountComponent,
	Notification_Modal,
	Modal
) {
	'use strict';

	return BaseView.extend({
		tagName: 'div',
		isRender: true,
		needsAuth: true,
		template: _.template(Template),
		events: {
			'click .termination-see-more': 'showSunsettingModal',
			'click .js-wellness-panel-resources-btn': 'togglePartnerResources',
			'click .js-wellness-panel-transaction-btn': 'goToTransactions',
		},
		initialize: function (options) {
			options = options || {};

			this.elementName = options.elementName;

			this.partner_data = pf.getContent('wellness');

			this.wellness_feature = pf.getFeature(enums.features.wellness);

			this.multipurse_feature = pf.getFeature(enums.features.wellness, {
				depth: 1,
				ids: [enums.features.multipurse],
			});

			// console.log('multipure_feature', this.multipurse_feature);

			this.site_version = pf.getContent('version.id');

			this.account = pf.wellness_account || null;
			this.accounts = null;
			this.logo = null;

			this.purses = [];

			BaseView.prototype.initialize(this);
		},

		render: function () {
			var that = this,
				template = null;

			that.buildLogoImg();
			this.loadWellnessAccount();

			if (this.multipurse_feature) {
				template = _.template(MultiPurseTemplate);

				this.loadMultiPurse();
			} else {
				template = _.template(Template);

				// this.loadWellnessAccount();
				this.getWellnessAccounts();
				if (isSunsetting()) {
					this.showSunsettingModal();
				}
			}

			this.$el
				.addClass(pf.getContent('wellness.class'))
				.html(template({ logo: that.logo }));

			this.addPartnerResources();

			this.addDisclaimers();

			return this;
		},

		loadData: function () {},

		showSunsettingModal: function (e) {
			if (e) {
				e.preventDefault();
				e.stopPropagation();
			}

			var termination_modal_view = new Notification_Modal(),
				modal = new Modal({
					show: true,
					content: termination_modal_view.$el.html(),
					calling_view: termination_modal_view,
				});
		},

		loadMultiPurse: function () {
			var multipurse_url = pf.url + '/Wellness/MultiPurse',
				that = this;

			$.ajax({
				url: multipurse_url,
				type: 'GET',
				contentType: 'application/json',
			})
				.done(function (response) {
					that.purses = response;
					that.addMultiPurses();
				})
				.complete(function () {});
		},

		addMultiPurses: function () {
			var that = this;

			that.$('.js-multipurse-list').empty();

			if (Array.isArray(this.purses)) {
				that.purses.forEach(function (purse) {
					var purse_view = new MultiPurseItemView({ data: purse });
					that.$('.js-multipurse-list').append(purse_view.el);
				});
			} else {
				console.warn('no purses found');
			}
		},

		loadWellnessAccount: function () {
			var that = this;

			// Force a re-load of wellness account, also reset variables
			pf.controller.wellness_account_called = false;
			pf.controller.wellness_account_callbacks = [];

			pf.controller.loadWellnessAccount(function () {
				that.account = pf.wellness_account;

				that.addAccountInfo();
			});
		},

		buildLogoImg: function () {
			var logo_content = pf.getContent('wellness.content.logo');

			if (_.isObject(logo_content)) {
				var features_logo = pf.getFeature(enums.features.wellness, {
						depth: logo_content.depth,
						ids: logo_content.ids,
					}),
					logo = pf.imageURL + features_logo.image_url;

				this.logo = logo;
			}

			console.log(logo, this.logo);
		},

		getWellnessAccounts: function () {
			var that = this,
				activities_url = pf.url + '/Wellness/Activities';

			$.ajax({
				type: 'GET',
				url: activities_url,
				contentType: 'application/json',
				success: function (response, status, options) {
					// console.log('getWellnessAccounts activities_url success',response, status, options);

					that.accounts = response;

					that.listWellnessAccounts();
				},
				error: function (response, status, options) {
					// console.log('getWellnessAccounts activities_url error',response, status, options);

					if (options.xhr.status == 412) {
						saveCipTriggerRoute('wellness');

						pf.navigate('register/financial/cip', { trigger: true });
					}
				},
			});
		},

		listWellnessAccounts: function () {
			if (_.isArray(this.accounts)) {
				for (var i = 0; i < this.accounts.length; i++) {
					var data = this.accounts[i],
						account = new AccountComponent({ data: data });

					this.$('.js-wellness-account-list').append(account.el);
				}
			}
		},

		addAccountInfo: function () {
			if (_.isObject(this.account)) {
				var expiration = moment(this.account.expiration_date).format(
						'MM/DD/YY'
					),
					balance = formatCurrency(this.account.balance),
					total_earned = formatCurrency(this.account.total_earned),
					total_spent = formatCurrency(this.account.total_spent),
					to_be_earned = formatCurrency(this.account.to_be_earned);

				// Update expiration
				this.$('.js-wellness-fund-expiration').html(expiration);

				// Update balance
				this.$('.js-wellness-fund-balance').html(balance);

				// Update total earned
				this.$('.js-total-earned').html(total_earned);

				// Update total spent
				this.$('.js-total-spent').html(total_spent);

				// Update to be earned
				this.$('.js-to-be-earned').html(to_be_earned);
			}
		},

		addPartnerResources: function () {
			var resources = pf.getContent('wellness.content.panel.resources');

			if (_.isObject(resources)) {
				var features_resources = pf.getFeature(enums.features.wellness, {
					depth: resources.depth,
					ids: resources.ids,
				});

				if (features_resources && _.isArray(features_resources.features)) {
					for (var i = 0; i < features_resources.features.length; i++) {
						var data = features_resources.features[i],
							resource = new PartnerResourceView({ data: data });

						this.$('.js-partner-resource-list').append(resource.el);
					}
				} else {
					this.$('.js-wellness-panel-resources-btn').css({ display: 'none' });
				}
			}
		},

		togglePartnerResources: function (e) {
			var btn = $(e.target),
				list = $('.js-partner-resource-list');

			if (btn.hasClass('closed')) {
				list.removeClass('closed');
				btn.removeClass('closed');
			} else {
				list.addClass('closed');
				btn.addClass('closed');
			}
		},

		addDisclaimers: function () {
			var partner_disclaimers = pf.getContent(
				'wellness.content.panel.disclaimers.partner'
			);
			var rewards_disclaimers = pf.getContent(
				'wellness.content.panel.disclaimers.rewards'
			);

			this.addDisclaimer(partner_disclaimers, '.js-partner-disclaimer');

			this.addDisclaimer(rewards_disclaimers, '.js-rewards-disclaimer');
		},

		addDisclaimer: function (disclaimers, cls) {
			if (_.isObject(disclaimers)) {
				var disclaimer = pf.getFeature(enums.features.wellness, {
					depth: disclaimers.depth,
					ids: disclaimers.ids,
				});

				if (_.isObject(disclaimer)) {
					this.$(cls).html(disclaimer.text);
				}
			}
		},

		goToTransactions: function (e) {
			e.preventDefault();

			pf.navigate('transactions');
		},

		close: function () {},
	});
});

